import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const BrandingContext = createContext({ branding: null, refresh: () => {} });
const VARS = {
  sidebar: "--brand-sidebar", primary: "--brand-primary", accent: "--brand-accent", background: "--brand-bg",
  sidebar_text: "--sidebar-text", sidebar_muted: "--sidebar-muted", nav_active: "--nav-active",
  nav_active_text: "--nav-active-text", heading_text: "--heading-text", body_text: "--body-text",
};

export function applyProfile(p) {
  if (!p) return;
  try { localStorage.setItem("brand_profile", JSON.stringify(p)); } catch { /* ignore */ }
  const root = document.documentElement.style;
  Object.entries(VARS).forEach(([k, v]) => { if (p[k]) root.setProperty(v, p[k]); });
  if (p.font_body) root.setProperty("--font-body", `'${p.font_body}'`);
  if (p.font_heading) root.setProperty("--font-heading", `'${p.font_heading}'`);
}

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);
  const refresh = useCallback(() => {
    api.get("/branding").then((r) => { setBranding(r.data); applyProfile(r.data.profile); }).catch(() => {});
    api.get("/branding/public").then((r) => applyFavicon(r.data.favicon_url, r.data.favicon_svg_url)).catch(() => {});
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return <BrandingContext.Provider value={{ branding, refresh }}>{children}</BrandingContext.Provider>;
}

export const useBranding = () => useContext(BrandingContext);

export const logoSrc = (path) => (path ? `${process.env.REACT_APP_BACKEND_URL}${path}` : null);

export function applyFavicon(path, svgPath) {
  if (!path) return;
  const base = logoSrc(path);
  [["icon", 64], ["apple-touch-icon", 180]].forEach(([rel, size]) => {
    let el = document.querySelector(`link[rel='${rel}']`);
    if (!el) { el = document.createElement("link"); el.rel = rel; document.head.appendChild(el); }
    if (rel === "icon" && svgPath) { el.type = "image/svg+xml"; el.href = logoSrc(svgPath); return; }
    if (rel === "icon") el.type = "image/png";
    el.href = `${base}&size=${size}`;
  });
}

export function cachedJSON(key) {
  try { return JSON.parse(localStorage.getItem(key) || "null"); } catch { return null; }
}

export function applyCachedProfile() {
  const p = cachedJSON("brand_profile");
  if (p) applyProfile(p);
}
